import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Panel, Button } from 'react-bootstrap';
import { fetchChild, createChild, updateChild, getBadge } from './actions';
import {
	loadEnrolmentsForChild,
	ENROLMENTS_BY_CHILD_REQUEST, ENROLMENTS_BY_CHILD_SUCCESS, ENROLMENTS_BY_CHILD_FAILURE
} from '../enrolments/actions';
import { loadUnpagedGrades } from '../grades/actions';
import ChildSettingsForm from './SettingsForm';
import EnrolmentsTimeline from '../enrolments/Timeline';
import ReduxBlockUi from 'react-block-ui/redux';
import { withTranslation } from 'react-i18next';
import BackButton from '../../common/components/BackButton';
import MedicalInformation from './MedicalInformation';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import { saveAs } from 'file-saver';
import Notes from '../notes';
import authUtils from '../../auth/utils';
import { faCalendarDays, faEdit } from '@fortawesome/free-regular-svg-icons';
import { faMedkit, faChild } from '@fortawesome/free-solid-svg-icons';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleChildSettingsSubmit = this.handleChildSettingsSubmit.bind(this);
		this.generateBadge = this.generateBadge.bind(this);
	}

	componentDidMount() {
		const { match, fetchChild, loadEnrolmentsForChild, loadUnpagedGrades } = this.props;
		const childId = match.params.childId;
		if (childId) {
			loadUnpagedGrades();
			fetchChild(childId);
			loadEnrolmentsForChild(childId);
		}
	}

	handleChildSettingsSubmit(values) {
		const { history, parentId, child, createChild, updateChild } = this.props;

		Object.assign(values, { parentId });
		if (child) {
			updateChild(child.id, values);
		} else {
			createChild(values, history);
		}
	}

	generateBadge() {
		const { getBadge, child } = this.props;
		const onSuccess = (response) => this.saveFile(response);
		getBadge(child.id, onSuccess);
	}

	saveFile(response) {
		saveAs(response, `Badge_${this.props.child.fullName}.pdf`);
	}

	render() {
		const { parentId, child, enrolments, schoolYears, grades, genderTypes, enableCollectMedicalInformation, currentUser, selectedTab, requireChildSchool, t } = this.props;

		return <div>
			<BackButton style={{ marginBottom: '10px' }}>{t('Common_BackToList')}</BackButton>
			{child && <Button key='badge' bsStyle='warning' style={{ marginBottom: '10px', marginLeft: '10px' }} onClick={this.generateBadge}>{t('Child_GenerateBadge')}</Button>}
			<CollapsablePanel icon={faChild} title={t('Parent_Profile')} collapsed={selectedTab !== 'profile'}>
				<ChildSettingsForm parentId={parentId} onSubmit={this.handleChildSettingsSubmit} initialValues={child} genderTypes={genderTypes} requireChildSchool={requireChildSchool} />
			</CollapsablePanel>
			{child && enableCollectMedicalInformation && <CollapsablePanel icon={faMedkit} title={t('Child_Tab_MedicalInformation')} collapsed={selectedTab !== 'medical'}>
				<MedicalInformation childId={child.id} />
			</CollapsablePanel>}
			<CollapsablePanel icon={faCalendarDays} title={t('Parent_Tab_Enrolments')} collapsed={selectedTab !== 'enrolments' && selectedTab !== 'profile'}>
				<ReduxBlockUi block={ENROLMENTS_BY_CHILD_REQUEST} unblock={[ENROLMENTS_BY_CHILD_SUCCESS, ENROLMENTS_BY_CHILD_FAILURE]} renderChildren={false}>
					{(!enrolments || enrolments.length === 0) && <div style={{ textAlign: 'center', marginTop: '5px' }}>{t('List_Empty')}</div>}
					<EnrolmentsTimeline data={enrolments} schoolYears={schoolYears} grades={grades} />
				</ReduxBlockUi>
			</CollapsablePanel>
			{child && authUtils.hasPermission(currentUser, 'Notes') && <CollapsablePanel icon={faEdit} title={t('Child_Section_Notes')} collapsed={selectedTab !== 'notes' && selectedTab !== 'profile'}>
				<Notes reference={child.id} referenceType='Child' />
			</CollapsablePanel>}
		</div>;
	}
};

const mapStateToProps = (state, ownProps) => {
	const childId = ownProps.match.params.childId;
	const selectedTab = ownProps.match.params.tab || 'profile';

	const {
		entities: { children, grades, enrolments },
		configuration: { franchisor },
		filters: { enrolmentsByChild },
		lookups: { genderTypes, schoolYears },
		auth: { currentUser }
	} = state;

	const enrolmentsByChildFilter = enrolmentsByChild[childId] || { ids: [] };

	return {
		selectedTab,
		currentUser,
		child: children[childId],
		enrolments: enrolmentsByChildFilter.ids.map(id => enrolments[id]),
		grades,
		genderTypes,
		schoolYears,
		enableCollectMedicalInformation: franchisor && franchisor.enableCollectMedicalInformation,
		requireChildSchool: franchisor && franchisor.requireChildSchool
	};
};

export default connect(mapStateToProps, {
	fetchChild,
	createChild,
	updateChild,
	loadEnrolmentsForChild,
	loadUnpagedGrades,
	getBadge
})(withTranslation()(Details));